import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

const styles = {
    elementContainer: {
        display: 'block',
        padding: '0 20px',
        margin: '8px auto 0',
    },
    textBlockBasics: {
        fontSize: '14px',
        display: 'inline-block',
        color: '#999',
        lineHeight: '20px',
        textAlign: 'left',
    },
};

export default function DialogLowerSectionFormText(props) {
    return (
        <div style={styles.elementContainer}>
            <span style={styles.textBlockBasics}>
                {props.children}
            </span>
        </div>
    );
}

DialogLowerSectionFormText.displayName = displayName('Dialog/LowerSectionFormText');

DialogLowerSectionFormText.propTypes = {
    children: PropTypes.any.isRequired,
};
